module.exports = __webpack_public_path__ + "img/SR.50194f75.png";